"use strict";
module.exports = {
    USER_UPDATED: 'Användaren uppdaterades',
    USER_CREATED: 'Användaren skapades',
    USER_DISABLED: 'Användaren avaktiverad',
    USER_ENABLED: 'Användaren aktiverad',
    USER_JOINED_ORGANIZATION: 'Användaren lades till i organization',
    USER_PASSWORD_CHANGED: 'Lösenordet uppdaterat',
    USER_REQUIRED_CHANGE_PASSWORD: 'USER_REQUIRED_CHANGE_PASSWORD',
    USER_VALIDATED: 'Användaren validerad',
    USER_LOGGED_IN: 'Användaren loggade in',
    CATEGORY_TREE_UPDATED: 'Artikelkategori uppdaterad',
    CATEGORY_TREE_CREATED: 'Artikelkategori skapad',
    ORGANIZATION_UPDATED: 'ORGANIZATION_UPDATED',
    ORGANIZATION_CREATED: 'ORGANIZATION_CREATED',
    ORGANIZATION_PUBLISHED_ON_QVANTI: 'Leverantör publicerad på Qvanti',
    ORGANIZATION_UNPUBLISHED_ON_QVANTI: 'Leverantör avpublicerad från Qvanti',
    SHOP_CONFIG_UPDATED: 'Webshop omkonfigurerad',
    SHOP_CONFIG_CREATED: 'Whitelabel skapad',
    ALERT_CLOSED: 'Notis stängd',
    ALERT_UPDATED: 'Notis uppdaterad',
    ALERT_CREATED: 'Skapat notis',
    OFC_IN_SUPPLIER_GATEWAY_UPDATED: 'Lagerställe uppdaterat',
    OFC_IN_SUPPLIER_GATEWAY_CREATED: 'Lagerställe skapat',
};
